export default __webpack_public_path__ + "img/alima.c9db8dc7.jpg";